module.exports = __webpack_public_path__ + "img/8.5ebe8f1f.png";